import React, { Component } from 'react';
import { connect } from 'react-redux';
import ScoreEntry from '../ScoreEntry';
import { getHighScores } from '../../actions/actionCreators.js';
import { TweenMax, Sine } from 'gsap';

const mapStateToProps = state => {
    return {
        scores : state.scores
    }
}
const mapDispatchToProps = dispatch => {
    return {
        getHighScores : round => dispatch( getHighScores( round ) )
    }
};

class HighScoresView extends Component {

    back = (e) => {
        this.props.router.push('/');
    }

    componentDidMount () {
        this.props.getHighScores();
        this.animateEye();
    }

    componentWillUnMount() {
        TweenMax.killAll( true, true, true, true);
    }

    animateEye () {
        TweenMax.set(['#mover', '#eyelid', '#iris'], { autoAlpha: 0 });
        TweenMax.delayedCall(2, () => this.moveEye());
    }

    moveEye () {
        TweenMax.set(['#mover', '#iris'], { autoAlpha: 1 });
        TweenMax.delayedCall(1, () => this.squint());
    }
    
    squint () {
        TweenMax.set(['#eyelid'], { autoAlpha: 1 });
        TweenMax.to('#mover', 1, {x: -10, delay: 0.2, ease: Sine.easeOut, onComplete: () => this.randomMoves()})
    }

    randomMoves () {
        TweenMax.to('#mover', this.getRandomArbitrary(0.2, 1.2), {
            x: this.getRandomArbitrary(-15, 15), 
            y: this.getRandomArbitrary(-5, 5), 
            delay: this.getRandomArbitrary(0, 1.4), 
            ease: Sine.easeOut,
            onComplete: () => this.randomMoves()
        })
        if (Math.random() > 0.75) this.blink(); // 50-50 odds of blinking
    }

    blink() {
        TweenMax.set(['#mover', '#iris'], { autoAlpha: 0 });
        TweenMax.set(['#mover', '#iris'], { autoAlpha: 1, delay: 0.2 });
    }

    getRandomArbitrary(min, max) {
		return Math.random() * (max - min) + min;
	}

    render() {
        return (
            <div className="highscores">
                <div className="leaderboardeye">
                    <svg version="1.1" id="eyeinabox" x="0px" y="0px" viewBox="0 0 265.768 180.509" enableBackground="new 0 0 265.768 180.509" preserveAspectRatio="xMidYMid meet">
                        <polygon points="0,7.502 132.99,7.502 132.99,180.509 0,154.014 "/>
                        <polygon fill="#281E17" points="0,7.502 0,154.014 48.684,145.823 "/>
                        <polygon fill="#38281C" points="0,7.502 113.291,17.282 113.079,0 "/>
                        <polygon fill="#38281C" points="0,154.014 132.99,180.509 132.99,159.362 132.884,159.362 48.702,145.823 48.684,145.823 "/>
                        <polygon fill="#38281C" points="113.079,0 113.291,17.282 132.99,18.976 265.768,10.044 "/>
                        <polygon fill="#281E17" points="132.99,159.362 132.99,180.509 265.768,154.014 132.99,137.068 "/>
                        <polygon fill="#281E17" points="132.99,18.976 132.99,137.068 265.768,154.014 265.768,97.792 236.66,102.029 236.66,65.842 
                        265.768,63.3 265.768,10.044 "/>
                        <polygon fill="#38281C" points="236.66,65.842 236.66,102.029 265.768,97.792 265.768,63.3 "/>
                        <g id="iris">
                            <ellipse transform="matrix(0.3162 -0.9487 0.9487 0.3162 -6.3649 129.561)" fill="#455359" cx="86.697" cy="69.196" rx="26.837" ry="26.837"/>
                            <circle fill="#748489" cx="82.575" cy="66.63" r="20.974"/>
                        </g>
                        <g id="mover">
                            <circle fill="#721010" cx="84.514" cy="70.963" r="11.578"/>
                            <circle fill="#160E08" cx="84.514" cy="70.963" r="5.411"/>
                            <circle fill="#CECAC0" cx="76.846" cy="62.987" r="2.845"/>
                        </g>
                        <g id="eyelid">
                            <path d="M47.511,66.63c20.152-4.596,57.441-6.341,76.006,7.146c0,0-3.174-37.924-34.591-37.924S47.511,66.63,47.511,66.63z"/>
                            <path d="M123.517,77.109c-20.152,4.596-57.441,6.341-76.006-7.146c0,0,3.174,37.924,34.591,37.924S123.517,77.109,123.517,77.109z" />
                        </g>
                    </svg>
                </div>
                <div className="leaderboard">
                    <h1>HIGH SCORES</h1>
                    { this.props.scores.highscores !== undefined &&
                        this.props.scores.highscores
                            .sort((a, b) => a.score > b.score ? -1 : 1 : 0) // alphabetical by name 'place'
                            .map((user, index) => {
                                return <ScoreEntry 
                                    key={index}
                                    rank={index + 1}
                                    name={user.twitterHandle}
                                    score={user.score}
                                />
                            })
                    }
                </div>
                <div className="leaderboard-nav">
                    <button className="btnPill hover" onClick={this.back}>Back</button>
                </div>
            </div>
        );
    }
}

const HighScores = connect( mapStateToProps, mapDispatchToProps )( HighScoresView );
export default HighScores;


// WEBPACK FOOTER //
// ./src/components/scenes/HighScores.js